import * as enumModels from "../Models/EnumModels";
import {
    AlertType,
    CallStatuses,
    ComplainSearch_GroupBy,
    DeviceAllocationTypes,
    DeviceTypes,
    Glitch_RegistrationTypes,
    GlitchOperationActions,
    GlitchSearch_GroupBy,
    GlitchStatuses,
    JobOperationActions,
    Priorities,
    RecurrencePatterns,
    RecurrencePatterns_End,
    RecurrenceSearch_GroupBy,
    RecurrenceSort,
    SendMessageDestinationTypes,
    ShiftSetup_LogoutOptions,
    WorkOrderStatuses,
    WOSourceStatuses
} from "../Models/EnumModels";
import {isNumber} from "lodash";
import {UUID} from "angular2-uuid";

export class ListRequest {
    public PageNumber: number = 1;
    public PageSize: number = 25;
    public OrderBy: string;
}

export class MasterDataRequest {
    public MasterDataTypeID: enumModels.MasterDataTypes;
    public MasterDataID: number;
}

export class ComplainAttachment {
    public ComplainId: number;
    public FileName: string;
    public Base64String: string;
    public CallRegAttachmentId: number;
    public IsDeleted: boolean = false;
}

export class ComplainRegister {
    public IsKMTCategory: any;
    public IsControlWithKSV: any;
    public WorkorderId: number;
    public ComplainId: number;
    public PropertyId: number;
    public LocationId: number;
    public CategoryId: number;
    public CallDescriptionsId: number;
    public TritonReservationId: number;
    public Priority: number;
    public LoggedBy: number;
    public AssignedTo: number;
    public Vip: string;
    public IsGuestCall: boolean;
    public RequestedByGuestId: number;
    public RequestedByStaffId: number;
    public CurrentStatus: string;
    public ClosedReasonCode: number;
    public Remarks: string;
    public ReopenTime: Date;
    public Operation: JobOperationActions;
    public IsAutoAssign: boolean = true;

    public Attachments: Array<ComplainAttachment> = [];
    public Seen: string;

    public ClosedReasonCode_Park: number = 0;
    public ClosedReasonCode_Close: number = 0;
    public InventoryJobMappings?: any;

    public get IsClosed(): boolean {
        if (this.CurrentStatus == "CLS") return true;
        else return false;
    }

    public set IsClosed(value: boolean) {
        if (value) this.CurrentStatus = CallStatuses.Close;
        else this.CurrentStatus = CallStatuses.Register;
    }

    public get AttachmentCount(): number {
        if (this.Attachments == null) return 0;

        return this.Attachments.filter((a) => a.IsDeleted == false).length;
    }

    public ResetTime: number;
    public LastActionRemarks: string;

    public AssignedToName: string;
}

export class JobInventoryDetails {
  Id: number;
  EventId: number;
  EventType: string;
  InventoryItemId: number;
  CallDescriptionId: number;
  SelectedQuantity: number;
  UtilizedQuantity: number;
  InventoryItemType: number;
  TransactionType: number;
  RetryCount: number;
  IsProcessed: boolean;
  Message: string;
  PropertyId: number;
  StockLocationId: number;
  CreatedAt: string;
  UpdatedAt: string;
  ProcessedAt: string;
  GuestCheckInAt: string;
  GuestCheckOutAt: string;
}

export class InventoryItems {
  ComplainId: number;
  CallDescriptionId: number;
  InventoryItemId: number;
  DefaultQuantity : number;
  UtilizedQuantity: number;
  TenantId: number;
  StockLocationId: number;
  GuestCheckInAt: string;
  GuestCheckOutAt: string;
  InventoryItemType: number;
  InventoryTransactionType: number;
}

export class JobInventoryLocationsDetails {
  JobInventoryLocations: any[];
  JobInventoryGuestDetails: JobInventoryGuestDetails;
}
export class JobInventoryGuestDetails {
  GuestChechInAt: string;
  GuestCheckOutAt: string;
}

export class JobInventoryLocation {
  StockLocationId: number;
  Description: string;
}
export class InventoryItemsPayload {
    ComplainId: number;
    propertyId: number;
}
export class GuestInvDetails {
    GuestCheckInAt: any;
    GuestCheckOutAt: any;
}

export class AddPreferenceRequest {
    public GuestId: number;
    public CallDescriptionId: number;
    public SystemId: string;
}

export class GuestSearch extends ListRequest {
    public GuestId: number;
    public PropertyId: number;
    public Keyword: string;
    public TritonReservationId: number;
    public SendReservations: boolean = false;
    public ReservationStatus: number;
}

export class VisitorSearch extends ListRequest {
  PageNumber: number;
  PageSize: number;
  OrderBy: string;
  PropertyId: number;
  MobileNumber: string;
  EmailId: string;
  FirstName: string;
  LastName: string;
}

export class ComplainEnableKMT {
    ComplainId: number;
    PropertyId: number;
    CategoryId: number;
}

export class WOSearch {
   public PropertyIds : number[];
   public StaffIds : number[];
   public WorkOrderStatus: number[];
   public Source: number[];
}

// Helper to get only numeric enum values
function getEnumNumbers<T extends object>(enumObj: T): number[] {
  return Object.values(enumObj).filter((v) => typeof v === 'number') as number[];
}

// Define reusable filter constants
export const WODefaultFilters = {
  // Exclude parked, closed, cancelled
  ACTIVE_WORKORDER_STATUSES: getEnumNumbers(WorkOrderStatuses).filter(
    (status) =>
      ![
        WorkOrderStatuses.Parked,
        WorkOrderStatuses.Closed,
        WorkOrderStatuses.Cancelled
      ].includes(status)
  ),
  // Exclude PM WOs
  VALID_SOURCES: getEnumNumbers(WOSourceStatuses).filter(
    (src) => src !== WOSourceStatuses.PM
  )
};

export class ComplainSearch extends ListRequest {
    public ComplainId: number;
    public Properties: Array<number>;
    public AllPending: boolean;
    public OpenOnly: boolean;
    public Keyword: string;
    public StatusCode: string;
    public CallDescriptions: Array<number>;
    public CallCategories: Array<number>;
    public Sections: Array<number>;
    public Departments: Array<number>;
    public VIPCodes: Array<string>;
    public AssignedTo: Array<number>;
    public Locations: Array<number>;
    public RequestedBy: Array<number>;
    public LoggedBy: Array<number>;
    public IsGuestCall: boolean;
    public GroupBy: ComplainSearch_GroupBy = ComplainSearch_GroupBy.None;
    public EscalationLevel: Array<number>;
    public Version: number;
    public CallNo: number;
    public RequestedByGuestId: number;
    public TritonReservationId: number;
    public Priorities: Array<number>;
    public Priority: Priorities;
    public IsKmt: boolean;
    public HasAttachment: number;
    public HasEscalation: number;
    public TaggedStaffIds: Array<number>;
    public StaffsInvolved: Array<number>;
    public LoggedDateRange: number;

    public SetDefaults(): void {
        this.PageNumber = 1;
        this.PageSize = 25;
        this.StatusCode = CallStatuses.Open;
        this.Properties = [];
        this.GroupBy = ComplainSearch_GroupBy.None;
    }

    public get HasFilters(): boolean {
        if (this.Keyword != null && this.Keyword.length > 0) return true;
      
        if (
            (this.CallCategories && this.CallCategories.length > 0) ||
            (this.CallDescriptions && this.CallDescriptions.length > 0) ||
            (this.Sections && this.Sections.length > 0) ||
            (this.Departments && this.Departments.length > 0) ||
            (this.VIPCodes && this.VIPCodes.length > 0) ||
            (this.AssignedTo && this.AssignedTo.length > 0) ||
            (this.Locations && this.Locations.length > 0) ||
            (this.RequestedBy && this.RequestedBy.length > 0) ||
            (this.LoggedBy && this.LoggedBy.length > 0) ||
            (this.CallNo && this.CallNo > 0) ||
            this.IsGuestCall != null ||
            this.IsKmt != null ||
            this.HasAttachment != null ||
            this.HasEscalation != null ||
            (this.TaggedStaffIds && this.TaggedStaffIds.length > 0) ||
            (this.StaffsInvolved && this.StaffsInvolved.length > 0) ||
            this.Priority ||
            this.LoggedDateRange || this.LoggedDateRange != null
        )
            return true;

        return false;
    }
}

export class RecurrenceSearch extends ListRequest {
    public PropertyId: number;
    public RecurrenceId: number;
}

export class RecurrenceQuery extends ListRequest {
    public Properties: Array<number> ;
    public RecurrenceId?: number;
    public CallDescriptions?: Array<number> ;
    public Locations?: Array<number> ;
    public Departments?: Array<number>;
    public lstEndPattern?: Array<number> = [];
    public LoggedBy?: Array<number>;
    public RequestedBy?: Array<number>;
    public ReportedBy?: Array<number>;
    public RecurrenceFrequency?: number;
    public RecurrencePattern?: number;
    public RegisterAtEndOfMonth?: boolean;
    public Keyword?: string;
    public StatusCode?: string;
    public IsGuestCall?: boolean;
    public ReopenStartTime?: Date;
    public ReopenEndTime?: Date;
    public LastUpdateStartTime?: Date;
    public LastUpdateEndTime?: Date;
    public Dow?: string;
    public RoomStatus = '';
    public DateRangeStart?: Date;
    public DateRangeEnd?: Date;
    public OrderBy: RecurrenceSort = RecurrenceSort.LastUpdateTimeDesc;
    public GroupBy?: RecurrenceSearch_GroupBy = RecurrenceSearch_GroupBy.None;
}

export class RecurrenceFilterModel extends RecurrenceQuery {
    public Months: number;

    public SetDefaults(): void {
        this.PageNumber = 1;
        this.PageSize = 25;
        this.StatusCode = "Y";
        this.Months = 1;
        this.RoomStatus = "";
        this.lstEndPattern = [];
    }

    public ClearFilter(): void {
        this.RoomStatus = "";
        this.lstEndPattern = [];
        this.Departments = [];
        this.Locations = [];
        this.CallDescriptions = [];
        this.DateRangeEnd = null;
        this.DateRangeStart = null;
    }

    public get HasFilters(): boolean {
        if (
            (this.CallDescriptions && this.CallDescriptions.length > 0) ||
            (this.Departments && this.Departments.length > 0) ||
            (this.Locations && this.Locations.length > 0) ||
            (this.lstEndPattern && this.lstEndPattern.length > 0) ||
            this.RoomStatus ||
            this.DateRangeStart ||
            this.DateRangeEnd
        )
            return true;

        return false;
    }
}

export class StaffAssignmentFilter {
    public PropertyId: number;
    public DepartmentID: number;
    public IncluedAllstaff: boolean;
    public AllPropertyCallCount: boolean;
}

export class RecurrenceRegister extends ComplainRegister {
    public RecurrenceId: number;
    public MaxRecurrence: number;
    public Dow: string;
    public RecurrencePattern: RecurrencePatterns;
    public StartDateTime: Date;
    public EndDateTime: Date;
    public EndPattern: RecurrencePatterns_End;
    public RecurrenceFrequency: number;
    public RoomStatus: string;
    public RegisteredAtEndOfMonth: boolean;
}

export class ShiftSetUpModel {
    public PropertyIds: Array<number>;
    public PropertyId: number;
    public ShiftId: number;
    public ShiftName: string;
    public DeptId: number;
    public DeptName: string;
    public SkillId: number;
    public IsNewShift: boolean;
    public SectionId: number;
    public PerShiftSkillEnabled = enumModels.ShiftSetupLoadOptions.CommonSkills;
}

export class SaveShiftResponse {
    public PropertyId: number;
    public ShiftId: number;
    public SectionStaffMapping: Array<any> = [];
    public DeptId: number;
    public ShiftName: string = "";
    public IsShiftActivated: boolean = false;
    public Notes: string = "";
    public MultiLingualShiftNameAndNotes: Array<any> = [];
    public ListStaffSkills: Array<StaffSkill> = [];
    public PerShiftSkillEnabled = false;
}

export class StaffDevice {
    public StaffId: number;
    public DeviceId: number;
    public DeviceType: DeviceTypes;
    public DeviceNumber: string;
    public IsPrimary: boolean;
    public IsEnabled: boolean;
    public DeviceName: string;
    public DeviceAllocationType: DeviceAllocationTypes;
}
export class StaffSkill {
    public StaffId: number = 0;
    public Skills: Array<any> = [];
}

export class RecurrenceLookup extends ListRequest {
    public RecurrenceId: number;
}

export class ShiftSetupFilter {
    public StaffMapped: string;
    public ServiceStatus: string;
    public SkillId: number;
    public LoginStatus: string;
    public Keyword: string;
    public OnlySelectedStaff: boolean;
    public SectionId: number;
    public StaffId: number;

    public ClearFilters(): void {
        this.StaffMapped = "";
        this.ServiceStatus = "";
        this.SkillId = 0;
        this.LoginStatus = "";
        this.Keyword = "";
        this.OnlySelectedStaff = false;
        this.SectionId = 0;
        this.StaffId = 0;
    }

    public get HasFilters(): boolean {
        if (
            this.StaffMapped != "" ||
            this.ServiceStatus != "" ||
            this.SkillId > 0 ||
            this.LoginStatus != "" ||
            this.Keyword != "" ||
            this.OnlySelectedStaff == true ||
            this.SectionId > 0
        ) {
            return true;
        }
        return false;
    }
}

export class CurrentReservationSearch extends ListRequest {
    public GuestId: number;
    public PropertyId: number;
    public Keyword: string;
    public TritonReservationId: number;
    public ReservationStatus: number;
    public Locations: Array<number>;
    public TaggedStaffIds: Array<number>;
    public VIPCodes: Array<string>;
    public StartDate?: Date;
    public EndDate?: Date;
    public HasGlitchRegistered?: boolean;
    public Properties: Array<number>;
    public PAX: number;
    public HasCallRegistered: number;
    public HasGuestMembership: number;

    public SetDefaults(): void {
        this.ReservationStatus = 2;
        this.OrderBy = "LocationDescription asc";
        this.Keyword = "";
        this.TaggedStaffIds = [];
    }

    public get HasFilters(): boolean {
        if (this.Keyword != null && this.Keyword.length > 0) return true;

        if (
            (this.Locations && this.Locations.length > 0) ||
            (this.VIPCodes && this.VIPCodes.length > 0) ||
            (this.TaggedStaffIds && this.TaggedStaffIds.length > 0) ||
            this.HasGlitchRegistered ||
            this.PAX != null ||
            this.HasCallRegistered != null ||
            this.HasGuestMembership != null
        )
            return true;

        return false;
    }
}

export class GuestAlert {
    public GuestId: number;
    public ReservationId: number;
    public AlertType: AlertType;
}

export class ReservationTracesRequest {
    public PropertyId: number;
    public PMSReservationId: string;
}

export class LoginLogoutRequest {
    public Properties: Array<number>;
    public StaffId: number;
    //public DeptId: number;
    public IsLogin: boolean;
    public logoutOptionComplain: Array<LogoutComplainRequest>;
    public logoutOptionWO?: Array<LogoutWORequest>
}

export class LoginLogoutWORequest {
    public WorkOrderId : number;
    public PropertyId : number;
    public LogoutOption : number;
    public LeadStaffId? : number;
}
export class LogoutComplainRequest {
    public ComplainId: number;
    //public PropertyId: number;
    public LogoutOption: ShiftSetup_LogoutOptions;
    public AssignedTo: number;
}

export class LogoutWORequest{
    public WOId: number;
    public LogoutOption: ShiftSetup_LogoutOptions;
    public AssignedTo: number;
    public PropertyId?: number;
}

export class ComplainGSRAnswers {
    public PropertyId: number;
    public ComplainId: number;
    public ListGSRRating: Array<GSRRating>;
    public GuestRemarks: string;
}

export class GSRRating {
    public QuestionId: number;
    public Rating: number;
}

export class StaffMessageRequest {
    public Message: string;
    public GroupId: number = 0;
    public StaffId: number = 0;
    public PropertyId: number;
    public EntityId: number;
    public EntityCode: string;
    public SendMessageDestinationType: SendMessageDestinationTypes =
        SendMessageDestinationTypes.Staff;

    public SetDefaults(): void {
        this.Message = null;
        this.GroupId = 0;
        this.StaffId = 0;
        this.SendMessageDestinationType = SendMessageDestinationTypes.Staff;
        this.EntityCode = null;
        this.EntityId = null;
    }
}

export class GetDepartmentDataRequest {
    public ShiftId: number;
    public DeptId: number;
    public PropertyId: number;
}

export class AddDeviceRequest {
    public PropertyId: number;
    public DeptId: number;
    public StaffId: number;
    public ListDevices: Array<StaffDevice>;
}

export class ChangePasswordRequest {
    public OldPassword: string;
    public NewPassword: string;
}

export class Filter_Update_Request {
    public StaffId: number;
    public JSONData: string;
    public EntityCode: string;
}

export class DeleteShiftRequest {
    public PropertyId: number;
    public DeptId: number;
    public ShiftId: number;
}

export class MessageOperationRequest {
    public MessageId: string;
    public Operation: enumModels.MessageOperations;
}

export class MessageSearch extends ListRequest {
    public StaffId: number;
    public Messages: Array<string>;
    public Properties: Array<number>;
    public Keyword: string;
    public EventId: number;
    public DeviceTypeId: number;

    public SetDefaults(): void {
        this.StaffId = null;
        this.Messages = [];
        this.Properties = [];
        this.Keyword = null;
        this.EventId = null;
        this.DeviceTypeId = null;
    }
}

export class TagStaffRequest {
    public EntityId: number;
    public EntityCode: string;
    public StaffIds: Array<number> = [];
    public StaffIdToAdd: number;
    public StaffIdToRemove: number;
    public StaffNames: Array<string> = [];
}

export class UploadImageRequest {
    public EntityId: number;
    public Base64String: string;
    public FileName: string;
    public FileSize: number;
}

export class ReservationStatusCount {
    public PropertyId: number;
    public StartDate?: Date;
    public EndDate?: Date;
}

export class Glitch_Visitor {
    public GlitchGuestId: number;
    public Title: string;
    public FName: string;
    public LName: string;
    public FullName: string;
    public MobileNumber: string;
    public HomeNumber: string;
    public Address: string;
    public Email: string;
}

export class GlitchAttachment {
    public GlitchId: number;
    public FileName: string;
    /*[SQLParam(Usage = SQLParamPlaces.None)]*/
    public Base64String: string;
    public GlitchAttachmentId: number;
    public IsDeleted: boolean;
}

export class Glitch_UpdateRequest extends Glitch_Visitor {
    public PropertyId: number;
    public GlitchId: number;
    public GlitchRegistrationType: Glitch_RegistrationTypes;
    public GlitchStaffId: number;
    public Details: string;
    public GuestTemperamentId: number;
    public GlitchIncedentDt: Date;
    public IncidentLocationId: number;
    public LocationName?: string;
    public DescriptionId: number;
    public DepartmentId: number;
    public TritonReservationId: number;
    public GlitchStaff: Array<number>;
    public TaggedStaff: Array<number>;
    public Attachments: Array<GlitchAttachment> = [];
    public Operation: GlitchOperationActions;
    public NoOfStays: number;
    public CheckInDate: Date;
    public CheckOutDate: Date;
    public LocationId: number;
    public RoomRate: number;
    public CategoryId: number;
    public OriginalLoggedDate: Date;
}

export class Glitch_SearchRequest extends ListRequest {
    public GlitchId: number;
    public GuestName: string;
    public Guests: Array<number>;
    public Reservations: Array<number>;
    public GlitchCategories: Array<number>;
    public GlitchDescriptions: Array<number>;
    public GlitchStaffs: Array<number>;
    public RegisteredBy: Array<number>;
    public TaggedStaffIds: Array<number>;
    public StaffsInvolved: Array<number>;
    public VIPCodes: Array<number>;
    public LoggedDateRange: number;
    public Locations: Array<number>;
    public Departments: Array<number>;
    public GlitchCallNo: number;
    public Properties: Array<number>;
    public Status: GlitchStatuses;
    public HasInvestigation: boolean;
    public HasRecovery: boolean;
    public GroupBy: GlitchSearch_GroupBy = GlitchSearch_GroupBy.None;
    public Keyword: string;
    public IgnoreCloseDays: boolean = false;
    //public HasFilters: boolean = false;

    public SetDefaults(): void {
        this.GlitchId = null;
        this.GuestName = null;
        this.Guests = [];
        this.Reservations = [];
        this.GlitchCategories = [];
        this.GlitchDescriptions = [];
        this.GlitchStaffs = [];
        this.RegisteredBy = [];
        this.TaggedStaffIds = [];
        this.StaffsInvolved = [];
        this.VIPCodes = [];
        this.Locations = [];
        this.Departments = [];
        this.GlitchCallNo = null;
        this.Status = GlitchStatuses.Open;
        this.HasInvestigation = null;
        this.HasRecovery = null;
        this.GroupBy = GlitchSearch_GroupBy.None;
        this.OrderBy = "LastUpdate desc";
        this.IgnoreCloseDays = false;
        //this.HasFilters = false;
    }

    public get HasFilters(): boolean {
        if (this.Keyword != null && this.Keyword.length > 0) return true;

        if (
            (this.GlitchCallNo && this.GlitchCallNo > 0) ||
            (this.GuestName && this.GuestName.length > 0) ||
            (this.Locations && this.Locations.length > 0) ||
            (this.Departments && this.Departments.length > 0) ||
            (this.GlitchCategories && this.GlitchCategories.length > 0) ||
            (this.GlitchDescriptions && this.GlitchDescriptions.length > 0) ||
            (this.GlitchStaffs && this.GlitchStaffs.length > 0) ||
            (this.RegisteredBy && this.RegisteredBy.length > 0) ||
            (this.TaggedStaffIds && this.TaggedStaffIds.length > 0) ||
            (this.StaffsInvolved && this.StaffsInvolved.length > 0) ||
            (this.VIPCodes && this.VIPCodes.length > 0) ||
            this.LoggedDateRange || this.LoggedDateRange != null ||
            this.HasInvestigation != null ||
            this.HasRecovery != null
        )
            return true;

        return false;
    }
}

export class Glitch_ActionRequest {
    public GlitchActionId: number;
    public GlitchId: number;
    public Operation: GlitchOperationActions;
    public RecoveryCost: number;
    public ReasonOrRecoveryId: number;
    public Remarks: string;
}

export class Device_SearchRequest extends ListRequest {
    public Keyword: string;
    public DeviceStatus: number;
    public OrderBy: string;
}

export class Device_UpdateRequest {
    public PropertyID: number;
    public WebSessionIDs: any[];
    public DeviceStatus: boolean;
}

export class DeviceInfo {
    public UserCodeID: number;
    public WebSessionID: number;
    public DeviceStatus: string;
    public ExpiryDate: boolean;
    public IdentifierToken: string;
}

/* Staff Health Questionnaire */

// view models

export class QuestionSetSearch extends ListRequest {
    public PropertyId: number;
    public Status: enumModels.QuestionSetStatus;
}

export interface AnswerValueOption<T = any> {
    label: string;
    uuid: string;
    original?: string;
    isValid?: boolean;
    value?: T;
}

export interface AnswerOptionAttributes {
    unit?: string;
    min?: number;
    max?: number;
}

export interface AnswerOption<T = any> {
    id: string;
    label: string;
    type: enumModels.AnswerTypes;
    attributes?: AnswerOptionAttributes;
    values?: AnswerValueOption<T>[];
}

export class AddEditQuestion<T = any> {
    public QuestionId: string;
    public QuestionDesc: string;
    public IsAnswerRequired: boolean;
    public IsSelected: boolean;
    public AnswerOption?: AnswerOption<T>;

    static reset<U = any>(): AddEditQuestion<U> {
        const model = new AddEditQuestion<U>();
        model.QuestionId = UUID.UUID();
        model.QuestionDesc = "";
        model.IsAnswerRequired = true;
        model.IsSelected = false;
        model.AnswerOption = null;
        return model;
    }
}

export class AddEditQuestionSet {
    public Id?: number;
    public PropertyId: number;
    public QuestionSetId: string;
    public QuestionSetName?: string;
    public Questions: AddEditQuestion[];

    static reset(propertyId: number): AddEditQuestionSet {
        const model = new AddEditQuestionSet();
        model.Id = null;
        model.PropertyId = propertyId;
        model.QuestionSetId = UUID.UUID();
        model.Questions = [];
        model.QuestionSetName = null;
        return model;
    }
}

// actual backend models

// add-edit
export class QuestionOptionRequest {
    Text: string;
    Value: string;
    UniqueId?: string;

    static from(
        option: AnswerValueOption,
        appendValue = false
    ): QuestionOptionRequest {
        const model = new QuestionOptionRequest();
        if (appendValue) {
            model.Value = option.value;
        }
        model.UniqueId = option.uuid;
        model.Text = option.label;
        return model;
    }

    static fromAnswer(answer: AnswerOption): QuestionOptionRequest[] {
        const type = answer && answer.type;
        const values = answer && answer.values;
        if (!type || !values) {
            return [];
        }
        if (
            type == enumModels.AnswerTypes.Text ||
            type == enumModels.AnswerTypes.Numerical
        ) {
            return [];
        }
        const appendValue =
            type == enumModels.AnswerTypes.OptionalBool ||
            type == enumModels.AnswerTypes.Rating;
        return values.map((o) => QuestionOptionRequest.from(o, appendValue));
    }
}

export class QuestionInsertUpdateRequest {
    Id: number;
    Type: enumModels.AnswerTypes;
    QuestionText: string;
    FailCondition?: string;
    IsAnswerRequired: boolean;
    CreatedBy: number;
    ExtraAttributes?: string;
    OptionRequests?: QuestionOptionRequest[];
    UniqueId: string;
    Position: number;

    static from(
        question: AddEditQuestion,
        index: number
    ): QuestionInsertUpdateRequest {
        const model = new QuestionInsertUpdateRequest();
        model.UniqueId = question.QuestionId;
        model.Type = question.AnswerOption.type;
        model.QuestionText = question.QuestionDesc;
        model.IsAnswerRequired = question.IsAnswerRequired;
        model.Position = index;
        model.ExtraAttributes = JSON.stringify(
            question.AnswerOption.attributes || {}
        );
        if (
            question.AnswerOption.values &&
            question.AnswerOption.values.length
        ) {
            model.OptionRequests = QuestionOptionRequest.fromAnswer(
                question.AnswerOption
            );
        }
        model.FailCondition =
            QuestionInsertUpdateRequest.createFailCondition(question);

        return model;
    }

    static createFailCondition(question: AddEditQuestion): string | null {
        let condition = null;
        // no question / answer found
        if (!question || !question.AnswerOption) {
            return null;
        }
        // question not mandatory
        if (!question.IsAnswerRequired) {
            return null;
        }
        const option = question.AnswerOption;
        switch (option.type) {
            case enumModels.AnswerTypes.Numerical:
                // value > max || value < min
                let microConditions = [];
                isNumber(option.attributes.max) &&
                    microConditions.push(`value > ${option.attributes.max}`);
                isNumber(option.attributes.min) &&
                    microConditions.push(`value < ${option.attributes.min}`);
                condition = microConditions.join(" || ");
                break;
            case enumModels.AnswerTypes.OptionalBool:
                // value == 0
                condition = `value == {${option.values[0].uuid}}`;
                break;
            case enumModels.AnswerTypes.Rating:
            case enumModels.AnswerTypes.Radio:
            case enumModels.AnswerTypes.Checkbox:
                // value == {guid} || value == {guid2} ...
                var invalidIds = (option.values || []).filter(
                    (o) => !o.isValid
                );

                const mapper = (o) => `value == {${o.uuid}}`;
                condition = invalidIds.map(mapper).join(" || ");
                break;
        }
        return condition;
    }
}

export class QuestionInsertUpdateViewModel extends QuestionInsertUpdateRequest {
    AnswerOption?: AnswerOption;

    static updateAnswer(
        question: QuestionInsertUpdateRequest
    ): QuestionInsertUpdateViewModel {
        let model = new QuestionInsertUpdateViewModel();
        model = { ...question };
        const attributes =
            question.ExtraAttributes && JSON.parse(question.ExtraAttributes);
        const answerOption: AnswerOption = {
            id: UUID.UUID(),
            attributes,
            type: question.Type,
            label: enumModels.AnswerTypesUtil.getLabel(question.Type),
            values: [],
        };

        // set values
        answerOption.values =
            question.OptionRequests &&
            question.OptionRequests.map((o) => {
                const option: AnswerValueOption = {
                    label: o.Text,
                    uuid: o.UniqueId,
                    value: o.Value,
                };

                return option;
            });
        // mark invalid options
        const failedConditions =
            QuestionInsertUpdateViewModel.parseFailConditions(
                question.FailCondition,
                question.Type == enumModels.AnswerTypes.Radio ||
                    question.Type == enumModels.AnswerTypes.Checkbox ||
                    question.Type == enumModels.AnswerTypes.Rating ||
                    question.Type == enumModels.AnswerTypes.OptionalBool
            );

        if (
            question.Type == enumModels.AnswerTypes.Radio ||
            question.Type == enumModels.AnswerTypes.Checkbox
        ) {
            answerOption.values.forEach(
                (v) => (v.isValid = !(failedConditions.indexOf(v.uuid) >= 0))
            );
        }

        //if (
        //    ) {
        //    answerOption.values
        //        .forEach(v => v.isValid = !(failedConditions.indexOf(v.value) >= 0))
        //}

        model.AnswerOption = answerOption;
        return model;
    }

    static parseFailConditions(
        failCondition: string,
        matchIds: boolean
    ): string[] {
        if (!failCondition || !failCondition.length) {
            return [];
        }
        const re = matchIds ? /value\s*==\s*\{(.*)\}/ : /value\s*==\s*(.*)/;

        return failCondition
            .split("||")
            .map((c) => {
                c = c.trim();
                const matches = re.exec(c) || [];
                // group values start from index 1
                return matches.length > 1 ? matches[1] : null;
            })
            .filter((c) => c !== null);
    }
}

export class QuestionSetInsertUpdateRequest {
    QuestionInsertUpdateRequests: QuestionInsertUpdateRequest[];
    TemplateName: string;
    PropertyId: number;

    static from(
        questionnaire: AddEditQuestionSet
    ): QuestionSetInsertUpdateRequest {
        const model = new QuestionSetInsertUpdateRequest();
        model.PropertyId = questionnaire.PropertyId;
        model.TemplateName = questionnaire.QuestionSetName;
        model.QuestionInsertUpdateRequests = questionnaire.Questions.map(
            QuestionInsertUpdateRequest.from
        );
        return model;
    }
}

// action
export class ChangeQuestionnaireStatusRequest {
    QuestionaireId: number;
    Status: enumModels.QuestionSetStatus;
    PropertyId: number;
}
